import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { environment } from '../environments/environment';
import { AuthenticationService } from './_services';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
	title = 'Marketful Sellers';
	currentUser: any;
	currentRole: any;

	location: Location;

	ngOnInit() {
		if (environment.production) {
		if (location.protocol === 'http:') {
			window.location.href = location.href.replace('http', 'https');
		}
		}
	}

	constructor(
	    private router: Router,
	    private authenticationService: AuthenticationService,
		private translate : TranslateService 
	) {
	    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
	    this.authenticationService.currentRole.subscribe(x => this.currentRole = x);
		translate.setDefaultLang('es');
	    // console.log("el rol es ");
	    // // console.log(this.currentUser.role)
	    // console.log(this.authenticationService.currentRole)
	    // // console.log(this.currentRole);
	    // console.log("fin del rol")
	}

	logout() {
		// console.log("vamos con el logout")
	    this.authenticationService.logout();
	    this.router.navigate(['/login']);
	}

	actualizar() {
		// console.log("entramos en Add Item en el app component")
	   this.authenticationService.currentRole.subscribe(x => this.currentRole = x);
	}
}
